import { ApiPlugin } from '@/plugins';

export default class SuggestionSearch {
  static stripHTML(html) {
    return html.replace(/(<([^>]+)>)/gi, '');
  }

  static preprocessSearch(search) {
    // check if search is an object and not an array
    if (search && typeof search === 'object' && !Array.isArray(search)) {
      /**
       * it can be an object like this:
       * { 1: "stringhtml", 2: "string2html", 3: "string3html" }
       *
       * convert it to an array like [ "stringhtml", "string2html", string3html ]
       */
      return Object.values(search);
    }

    // return if no matching types
    return search;
  }

  static processSearch(search) {
    const data = SuggestionSearch.preprocessSearch(search);
    return data?.map((item) => SuggestionSearch.stripHTML(item)) ?? [];
  }

  static async findSuggestionSearchByKey(key, regionTid) {
    const response = await ApiPlugin.get(`/suggested/searches/ajax/get/${regionTid ?? 0}/${key ?? ''}`);
    return response && SuggestionSearch.processSearch(response.data);
  }

  static getDefaultSearchParams() {
    if (window?.drupalSettings?.sante_resultats_edito?.what
      || window?.drupalSettings?.sante_resultats_edito?.where) {
      let { what, where } = window.drupalSettings.sante_resultats_edito;
      if (window?.drupalSettings.path.currentPath === 'autour-de-moi') {
        what = 'Toute l’offre de santé';
        where = 'Autour de moi';
      }
      return { what: what ?? '', where: where ?? '', currentPath: window.drupalSettings.path.currentPath };
    }
    return { what: '', where: '', currentPath: window?.drupalSettings?.path?.currentPath };
  }
}
